import React, { useState } from "react";
import { Modal, Button as BsButton } from "react-bootstrap";
import Select from "react-select";
import { ClipLoader } from "react-spinners";
import { SUBJECTS, GRADES_OPTIONS } from "../../services/constants";
import { mockStudents } from "../../services/auth";
import localization from "../../services/localization";

export function AddClassroomDialog({ onAdd, show, setShow, loading }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [subject, setSubject] = useState(null);
  const [grade, setGrade] = useState(null);
  const [resource, setResource] = useState(null);
  const [uploadFile, setUploadFile] = useState(null);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const studentOptions = mockStudents
    .filter((u) => u.role === "student")
    .map((s) => ({
      value: s.id,
      label: `${s.name} (${s.email})`,
    }));

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!name || !subject || !grade) return;

    const newClassroom = {
      name,
      description,
      subject: subject.value,
      grade: grade.value,
      resource: resource?.value || null,
      uploadFile,
      students: selectedStudents.map((s) => s.value),
    };
    onAdd(newClassroom);
    resetForm();
  };

  const resetForm = () => {
    setName("");
    setDescription("");
    setSubject(null);
    setGrade(null);
    setResource(null);
    setUploadFile(null);
    setShow(false);
  };

  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {localization.createNewClassroom || "Create New Classroom"}
        </Modal.Title>
      </Modal.Header>
      <form onSubmit={handleSubmit}>
        <Modal.Body className="space-y-4">
          <div>
            <label className="form-label">
              {localization.classroomName || "Classroom Name"}
            </label>
            <input
              type="text"
              className="form-control"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="e.g., Advanced Mathematics"
              required
            />
          </div>
          <div>
            <label className="form-label">
              {localization.description || "Description"}
            </label>
            <textarea
              className="form-control"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Brief description"
            />
          </div>
          <div>
            <label className="form-label">
              {localization.subject || "Subject"}
            </label>
            <Select
              options={SUBJECTS}
              value={subject}
              onChange={setSubject}
              placeholder="Select subject"
            />
          </div>
          <div>
            <label className="form-label">
              {localization.grade || "Grade"}
            </label>
            <Select
              options={GRADES_OPTIONS}
              value={grade}
              onChange={setGrade}
              placeholder="Select grade"
            />
          </div>
          <div>
            <label className="form-label">
              {localization.selectStudents || "Select Students"}
            </label>
            <Select
              isMulti
              options={studentOptions}
              value={selectedStudents}
              onChange={setSelectedStudents}
              placeholder="Choose students to enroll"
            />
          </div>
          <div>
            <label className="form-label">
              {localization.resource || "Resource"}
            </label>
            <Select
              options={[
                { value: "res1", label: "Resource 1" },
                { value: "res2", label: "Resource 2" },
                { value: "upload", label: "Upload New Resource" },
              ]}
              value={resource}
              onChange={setResource}
              placeholder="Select or upload"
            />
            {resource?.value === "upload" && (
              <input
                type="file"
                className="form-control mt-2"
                onChange={(e) => setUploadFile(e.target.files[0])}
              />
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <BsButton variant="secondary" onClick={() => setShow(false)}>
            {localization.cancel || "Cancel"}
          </BsButton>
          <BsButton type="submit" variant="primary">
            {loading ? (
              <div className="d-flex align-items-center gap-2">
                <ClipLoader size={20} color="var(--primary-icon)" />
                {localization.adding || "Adding"}...
              </div>
            ) : (
              `${localization.createClassroom || "Create Classroom"}`
            )}
          </BsButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
